import React, { useEffect, useState, } from "react";
import { Container, Row, Col, Card, Image, Form, Button } from "react-bootstrap";
import {
  FaCamera,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { editProfile, getuserProfile } from "../../store/slices/auth";
import { uploadImage } from "../../utils/helpers/fileupload";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function Profile() {
  const users = JSON.parse(localStorage.getItem("user"));
  const token = users?.data?.accessToken;

  const { profile: user } = useSelector((state) => state.auth);
  const [profileImage, setProfileImage] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const [formData, setFormData] = useState({
    logo: "",
    inclusion: "",
    exclusion: "",
    paymentPolicy: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.organization) {
      setFormData({
        logo: user.organization.logo || "",
        inclusion: user.organization.inclusion || "",
        exclusion: user.organization.exclusion || "",
        paymentPolicy: user.organization.paymentPolicy || "",
      });

      setProfileImage(user.organization.logo || "");
    }
  }, [user]);

  const handleProfileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const uploaded = await uploadImage(file, token);

      setProfileImage(uploaded);

      const updatedData = {
        ...formData,
        logo: uploaded,
      };

      setFormData(updatedData);

      await dispatch(editProfile(updatedData));
      await dispatch(getuserProfile());
    } catch (error) {
      console.error(error);
    }
  };
  const handleSave = async () => {
    const result = await dispatch(editProfile(formData));
    await dispatch(getuserProfile());

    if (editProfile.fulfilled.match(result)) {
      setIsEditing(false);
    }
  };


  return (
    <>
      <Container fluid style={{ background: "#f4f6fb", padding: "20px" }}>


        <Card
          className="border-0 shadow-sm"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            transition: "0.3s",
          }}
          onMouseEnter={(e) =>
          (e.currentTarget.style.boxShadow =
            "0 15px 35px rgba(45,12,87,0.25)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)")
          }
        >
          <div
            style={{
              height: "220px",
              background: "linear-gradient(135deg,#2d0c57,#3c1361)",
              position: "relative",
            }}
          >

          </div>

          <Card.Body style={{ marginTop: "-60px" }}>
            <Row className="align-items-center">
              <Col md={3} className="text-center mb-3 mb-md-0">

              </Col>

              <Col md={6} className="text-center">
                <div style={{ position: "relative", display: "inline-block" }}>
                  <Image
                    src={
                      profileImage
                        ? profileImage
                        : `https://ui-avatars.com/api/?name=${user?.name}&background=2d0c57&color=fff`
                    }
                    roundedCircle
                    style={{
                      width: "110px",
                      height: "110px",
                      border: "4px solid white",
                      objectFit: "cover",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.08)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />

                  <label
                    style={{
                      position: "absolute",
                      bottom: "0",
                      right: "0",
                      background: "#2d0c57",
                      color: "#fff",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                    }}
                  >
                    <FaCamera size={12} />
                    <input type="file" hidden onChange={handleProfileUpload} />
                  </label>
                </div>

                <h5 className="fw-bold mb-0">{user?.name}</h5>
                <p>
                  {user?.email}
                  <br />
                  {user?.mobileNumber}
                  <br />
                  {user?.organization?.name}
                </p>

              </Col>


            </Row>
          </Card.Body>
        </Card>

        <Row className="mt-4 g-4">

          <Col md={12}>
            <Card
              className="border-0 shadow-sm h-100"
              style={{ borderRadius: "12px" }}
            >
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold mb-0">
                    Organization Details
                  </h6>

                  {isEditing ? (
                    <Button size="md" onClick={handleSave}>
                      Save
                    </Button>
                  ) : (
                    <Button
                      size="md"
                      variant="outline-primary"
                      onClick={() => setIsEditing(true)}
                    >
                      Edit
                    </Button>
                  )}
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Inclusion</Form.Label>

                  {isEditing ? (
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.inclusion}
                      onChange={(event, editor) => {
                        const data = editor.getData();

                        setFormData((prev) => ({
                          ...prev,
                          inclusion: data,
                        }));
                      }}
                    />
                  ) : (
                    <div
                      className="border rounded p-3 bg-light"
                      dangerouslySetInnerHTML={{
                        __html: formData.inclusion || "<p>-</p>",
                      }}
                    />
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Exclusion</Form.Label>

                  {isEditing ? (
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.exclusion}
                      onChange={(event, editor) => {
                        const data = editor.getData();

                        setFormData((prev) => ({
                          ...prev,
                          exclusion: data,
                        }));
                      }}
                    />
                  ) : (
                    <div
                      className="border rounded p-3 bg-light"
                      dangerouslySetInnerHTML={{
                        __html: formData.exclusion || "<p>-</p>",
                      }}
                    />
                  )}
                </Form.Group>

                <Form.Group className="mb-5">
                  <Form.Label>Payment Policy</Form.Label>

                  {isEditing ? (
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.paymentPolicy}
                      onChange={(event, editor) => {
                        const data = editor.getData();

                        setFormData((prev) => ({
                          ...prev,
                          paymentPolicy: data,
                        }));
                      }}
                    />
                  ) : (
                    <div
                      className="border rounded p-3 bg-light"
                      dangerouslySetInnerHTML={{
                        __html: formData.paymentPolicy || "<p>-</p>",
                      }}
                    />
                  )}
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>


        </Row>
      </Container>
    </>
  );
}
